import {useState} from "react";
import {
    Button,
    ButtonProps
} from "@mantine/core";
import {AddFormDrawer} from "../drawers/AddFormDrawer.tsx";
import config from "../config/index.ts";
import {AiOutlinePlus} from "react-icons/ai";

export const AddRecordButton = (props: ButtonProps) => {


    const [drawerOpened, setDrawerOpened] = useState(false);


    if (drawerOpened) {
        return (
            <AddFormDrawer
                opened={drawerOpened}
                onClose={() => setDrawerOpened(false)}
            />
        );
    } else {
        return (
            <Button
                leftSection={<AiOutlinePlus/>}
                onClick={() => {
                    setDrawerOpened(true);
                }}
                {...props}
            >{`New ${config.titles.singular}`}</Button>
        );
    }


};
